// extracted by mini-css-extract-plugin
export var active = "_78-a";
export var activeIndicator = "_78-9";
export var disabled = "_78-b";
export var fullWidth = "_78-2";
export var lg = "_78-7";
export var md = "_78-6";
export var redoButtonTabGroup = "_78-0";
export var sm = "_78-5";
export var tabButton = "_78-4";
export var tabButtonsContainer = "_78-1";
export var themeDestructive = "_78-d";
export var themeNormal = "_78-c";
export var themeSuccess = "_78-e";
export var xl = "_78-8";
export var xs = "_78-3";